module.exports = __webpack_public_path__ + "img/avatar.6c552307.png";